import {useMemo, useRef, useState} from "react";
import {numberWithCommas} from "../../../utils/methods";
import DBButton from "../../../component/global/DBButton";
import DBCheckbox from "../../../component/global/DBCheckbox";
import FoodOrderItems from "./FoodOrderItems";
import {useTranslation} from "react-i18next";
import {ReactComponent as Pin} from "../../../asset/icons/pin.svg";
import {ReactComponent as Coin} from "../../../asset/icons/coin.svg";
import {get, post} from "../../../controlers/global/ConfigRequest";
import {CREATE_ORDER, GET_USED_DISCOUNT_CARD} from "../../universalData";

function FoodOrderModal({data, onDelete, onSuccess, companyId}) {
  const {t} = useTranslation()
  const [privacy, setPrivacy] = useState(false)
  const [error, setError] = useState('')
  const [discount, setDiscount] = useState('')
  const [discountError, setDiscountError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [table, setTable] = useState('')
  const [tableErr, setTableErr] = useState('')
  const inputRef = useRef(null)

  const list = useMemo(() => {
    const tmp = []
    for (const item of data) {
      const cardItems = item[0]?.restaurant_sale_cards?.[0]
      const count = item?.length || 1
      tmp.push({
        id: cardItems?.id,
        title: cardItems?.item_name || item[0]?.name,
        count,
        price: count * Number(cardItems?.price || 0),
        gift: count * Number(cardItems?.coin || 0)
      })
    }
    return tmp
  }, [data])

  const amount = useMemo(() => {
    let tmp = 0
    if (list?.length) {
      for (const item of list) {
        tmp += item.price
      }
    }
    return tmp
  }, [list])

  const tax = useMemo(() => amount * 0.09, [amount])

  const totalAmount = useMemo(() => amount + tax, [amount, tax])

  const totalGift = useMemo(() => {
    let tmp = 0
    if (list?.length) {
      for (const item of list) {
        tmp += item.gift
      }
    }
    return tmp
  }, [list])

  const tableHandle = (e) => {
    const patt = new RegExp(/^\+?([0-9]*)$/);
    if (patt.test(e.target.value) || e.target.value === "") {
      setTableErr("");
      setTable(e.target.value);
    }
  }

  return (
    <>
      <input
        value={table}
        className='food-order-table'
        placeholder={t('feedback.login.table.placeholder')}
        inputMode='decimal'
        onChange={tableHandle}
      />
      {tableErr ?
        <div className='food-order-error'>
          {tableErr}
        </div>
        : null}
      <ul className='food-order-modal-list'>
        {list.map((item, index) => <FoodOrderItems key={index} data={item} onClick={() => onDelete?.(index)}/>)}
      </ul>
      <div className='food-order-modal-amount-calc'>
        <div>
          {numberWithCommas(`${amount}`)}
        </div>
        <div className='food-order-modal-tax'>
          <div className='food-order-modal-tax-title'>
            ٪ {t("fee")}
          </div>
          <div>
            {numberWithCommas(`${tax}`)}
          </div>
        </div>
      </div>
      <div className='food-order-modal-total-amount'>
        {numberWithCommas(`${totalAmount}`)}
      </div>
      <div className='food-order-discount-container'>
        <div className='food-order-discount-logo'>
          <Pin/>
        </div>
        <div className='food-order-discount'>
          <input disabled={isLoading} ref={inputRef} type='text' placeholder={t("discount")}/>
          <DBButton
            loading={isLoading}
            className='food-order-discount-btn'
            onClick={() => {
              const input = inputRef.current
              const value = input.value
              if (input.value) {
                const company = companyId
                const user = sessionStorage.getItem('id')
                const code = value
                const nowDate = new Date()
                const year = nowDate.getFullYear()
                const month = nowDate.getMonth() + 1
                const day = nowDate.getDate()
                const date = year + '-' + month + '-' + day
                setIsLoading(true)
                get(GET_USED_DISCOUNT_CARD, {company, user, code, date})
                  .then(res => {
                    if (res?.result?.length) {
                      const discountId = res.result[0]?.discount_card?.id
                      setDiscount(discountId)
                      setDiscountError('')
                    } else {
                      setDiscountError(t('feedback.discount.error'))
                      setDiscount('')
                    }
                  })
                  .catch(err => {
                    console.log('GET_USED_DISCOUNT_CARD err', err)
                    setDiscountError(t('feedback.discount.error'))
                    setDiscount('')
                  })
                  .finally(() => setIsLoading(false))
              }
            }}
            caption={t("apply")}
          />
        </div>
      </div>
      {discountError ?
        <div className='food-order-error'>
          {discountError}
        </div>
        : null}
      <div className='food-order-gift'>
        <div>
          {t("our.prize")}
        </div>
        <div>
          <span>{totalGift}</span><Coin/>
        </div>
      </div>
      <div className='food-order-privacy'>
        <DBCheckbox
          checked={privacy}
          onClick={() => {
            setError('')
            setPrivacy(prevState => !prevState)
          }}
        />
        <div className='food-order-privacy-text'>
          {t('form.rules.checkbox').split("*")[0]}
          <span>{t('form.rules.checkbox').split("*")[1]}</span>{t('form.rules.checkbox').split("*")[2]}
        </div>
      </div>
      {error ?
        <div className='food-order-error'>
          {error}
        </div>
        : null}
      <DBButton
        loading={isLoading}
        className='food-order-btn'
        caption={t("feedback.send")}
        onClick={() => {
          if (!privacy || !table) {
            if (!privacy) setError(t('feedback.privacy.error'))
            if (!table) setTableErr(t('feedback.table.error'))
            return true
          }
          const order_items = list.map(item => ({sale_card: item.id, quantity: item.count}))
          const body = {
            company: companyId,
            order_items,
            table: +table
          }
          if (discount) {
            body.used_discount_card = discount
          }
          // const user = sessionStorage.getItem('id')
          // const auth = sessionStorage.getItem('auth')
          // if (!user || !auth) {
          //   onLogin?.(body)
          //   return true
          // }
          setIsLoading(true)
          post(CREATE_ORDER, body)
            .then(res => {
              console.log('CREATE_ORDER res', res)
              if (res?.id) {
                onSuccess?.(res)
              }
            })
            .catch(err => {
              console.log('CREATE_ORDER err', err)
            })
            .finally(() => setIsLoading(false))
        }}
      />
    </>
  );
}

export default FoodOrderModal;
